// ── useKalshiAccount — Auto-connect lifecycle hook ──────────────
// Mirrors useHydra pattern. On mount, checks localStorage for saved
// credentials and connects if found. Disconnects on unmount.

import { useEffect } from 'react';
import { useAccountStore } from '../stores/accountStore';
import type { KalshiCredentials } from '../types/kalshi';

const STORAGE_KEY = 'g1xl_kalshi_credentials';

export function useKalshiAccount(): void {
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const creds: KalshiCredentials = JSON.parse(saved);
        if (creds.keys?.length > 0) {
          useAccountStore.getState().connect(creds);
        }
      } catch {
        // Invalid saved data — ignore, user can re-enter in Settings
      }
    }

    return () => {
      useAccountStore.getState().disconnect();
    };
  }, []);
}
